import React from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  ToggleButton,
  ToggleContent,
  ToggleLabel,
  FilterCount
} from './styles';

export const MobileFilterToggle = ({
  isOpen,
  onToggle,
  filterCount = 0,
  label = 'Filters'
}) => (
  <ToggleButton onClick={onToggle}>
    <ToggleContent>
      <FilterListIcon fontSize="small" />
      <ToggleLabel>{label}</ToggleLabel>
      {filterCount > 0 && (
        <FilterCount>{filterCount}</FilterCount>
      )}
    </ToggleContent>
    {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </ToggleButton>
);
